import { alsfrs } from '../../../questionnaires/alsfrs'
import QuestionnairePage from '../../../components/QuestionnairePage'
import QuestionnaireInterfaceToggle from '../../../components/QuestionnaireInterfaceToggle'
import useQuestionnaireInterface from '../../../hooks/useQuestionnaireInterface'
import useReportMonthGuard from '../../../hooks/useReportMonthGuard'

export default function ALSFRSPage() {
  const isValidated = useReportMonthGuard()
  const { questionnaireInterface, setQuestionnaireInterface } =
    useQuestionnaireInterface()

  if (!isValidated) {
    return null // Don't render anything until month is validated
  }

  return (
    <QuestionnairePage
      interfaceStyle={questionnaireInterface}
      interfaceToggle={
        <QuestionnaireInterfaceToggle
          onChange={setQuestionnaireInterface}
          value={questionnaireInterface}
        />
      }
      questionnaire={alsfrs}
    />
  )
}
